import { getPermittedAccounts } from 'api/transfers/service';
import {
  getPermittedFundingAccts,
  getPermittedLoanAccts,
  getWireAccounts
} from 'api/payments/service';
import { PAYMENT_TYPES } from 'constants.js';
import { BALANCE_KEY } from './constants';

const { LOAN } = PAYMENT_TYPES;

export const PAYLOAD = {
  PAYMENTS: { paymentType: LOAN.PAYMENT },
  DRAWS: { paymentType: LOAN.DRAW },
  TRANSFER_ACCOUNTS_FROM: { showBalance: true, locAccountBalanceType: 'CurrentAvailable' },
  TRANSFER_ACCOUNTS_TO: { showBalance: true, locAccountBalanceType: 'CurrentPrincipal' },
  WIRE_TEMPLATES_ONLY: { includeTemplateOnlyAccounts: true },
  WIRE_NOT_TEMPLATES_ONLY: { includeTemplateOnlyAccounts: false }
};

export const accountBalServiceMapping = {
  internationalWire: {
    api: getWireAccounts,
    payload: PAYLOAD.WIRE_NOT_TEMPLATES_ONLY,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  domesticWire: {
    api: getWireAccounts,
    payload: PAYLOAD.WIRE_NOT_TEMPLATES_ONLY,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  singleTransferFrom: {
    api: getPermittedAccounts,
    payload: PAYLOAD.TRANSFER_ACCOUNTS_FROM,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  singleTransferTo: {
    api: getPermittedAccounts,
    payload: PAYLOAD.TRANSFER_ACCOUNTS_TO,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  fromAccount: {
    api: getWireAccounts,
    payload: PAYLOAD.WIRE_TEMPLATES_ONLY,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  recurTransferDebit: {
    api: getPermittedAccounts,
    payload: PAYLOAD.TRANSFER_ACCOUNTS_FROM,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  recurTransferCredit: {
    api: getPermittedAccounts,
    payload: PAYLOAD.TRANSFER_ACCOUNTS_TO,
    balanceKey: BALANCE_KEY.BALANCE,
    getBalance: (data) => data?.[0]?.balance
  },
  loanPaymentLoan: {
    api: getPermittedLoanAccts,
    payload: PAYLOAD.PAYMENTS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCES,
    getBalance: (data) => data?.loanAccounts?.accountDetails?.[0]?.accountBalances
  },
  loanPaymentFunding: {
    api: getPermittedFundingAccts,
    payload: PAYLOAD.PAYMENTS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCES,
    getBalance: (data) => data?.fundingAccounts?.accountDetails?.[0]?.accountBalances
  },
  initLoanPaymentFrom: {
    api: getPermittedFundingAccts,
    payload: PAYLOAD.PAYMENTS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCE,
    getBalance: (data) => data?.fundingAccounts?.accountDetails?.[0]?.accountBalances
  },
  initLoanPaymentTo: {
    api: getPermittedLoanAccts,
    payload: PAYLOAD.PAYMENTS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCE,
    getBalance: (data) => data?.loanAccounts?.accountDetails?.[0]?.accountBalances
  },
  initLoanDrawFrom: {
    api: getPermittedLoanAccts,
    payload: PAYLOAD.DRAWS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCE,
    getBalance: (data) => data?.loanAccounts?.accountDetails?.[0]?.accountBalances
  },
  initLoanDrawTo: {
    api: getPermittedFundingAccts,
    payload: PAYLOAD.DRAWS,
    balanceKey: BALANCE_KEY.ACCOUNT_BALANCE,
    getBalance: (data) => data?.fundingAccounts?.accountDetails?.[0]?.accountBalances
  }
};
